export default __webpack_public_path__ + "static/ssalloway-d369e6d4e57cd3000495d15463b4bbe1.jpg";